import type { Channel } from "@/utils/fileImport/channels"
import { ALPHA_QUANTITY_SOLD, ALPHA_VARIANT_ID } from "@/utils/alphaModel"

export const headers = [
  [
    "amazon-order-id",
    "merchant-order-id",
    "purchase-date",
    "last-updated-date",
    "order-status",
    "fulfillment-channel",
    "sales-channel",
    "order-channel",
    "url",
    "ship-service-level",
    "product-name",
    "sku",
    "asin",
    "item-status",
    "quantity",
    "currency",
    "item-price",
    "item-tax",
    "shipping-price",
    "shipping-tax",
    "gift-wrap-price",
    "gift-wrap-tax",
    "item-promotion-discount",
    "ship-promotion-discount",
    "ship-city",
    "ship-state",
    "ship-postal-code",
    "ship-country",
    "promotion-code",
  ],
]

const channel: Channel = {
  headers,
  dateFormats: {
    Date: "YMD",
  },
  blockMap: {
    [ALPHA_QUANTITY_SOLD]: {
      target: "quantity",
      columns: {
        [ALPHA_VARIANT_ID]: "product-name",
        Date: "purchase-date",
      },
      notInFile: {
        Channel: "Amazon",
      },
    },
  },
}

export default channel
